export enum TargetType {
  Branch = "branch",
  Employee = "employee",
  Trash = "trash",
  Warehouse = "warehouse",
}
